// Search highlight + snippet utilities. Lifted from the design's helpers.jsx
// and adapted for our Capture shape.

import { Fragment, type ReactNode } from "react";

import type { Capture } from "./api";

export function highlight(text: string, query: string): ReactNode {
  const q = query.trim();
  if (q.length < 2) return text;
  const re = new RegExp(`(${q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "ig");
  const parts = text.split(re);
  return parts.map((part, i) =>
    re.test(part) && part.toLowerCase() === q.toLowerCase() ? (
      <mark key={i}>{part}</mark>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    ),
  );
}

// Build a snippet centred on the first match across summary/body/tags.
// Falls back to the summary if nothing matches.
export function makeSnippet(item: Capture, query: string, maxBefore = 30, maxAfter = 50): string {
  const haystacks = [item.summary, item.body, item.tags.join(" ")].filter(Boolean);
  if (!query || query.trim().length < 2) return item.summary;
  const q = query.trim().toLowerCase();
  for (const h of haystacks) {
    const idx = h.toLowerCase().indexOf(q);
    if (idx === -1) continue;
    if (h === item.summary) return item.summary;
    const start = Math.max(0, idx - maxBefore);
    const end = Math.min(h.length, idx + q.length + maxAfter);
    let snip = h.slice(start, end).replace(/\s+/g, " ").trim();
    if (start > 0) snip = "…" + snip;
    if (end < h.length) snip = snip + "…";
    return snip;
  }
  return item.summary;
}
